import { render } from "./list.vue?vue&type=template&id=6ed4f45c"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-house/layout6/list.vue'],['render',render],['__file',"list.vue"]])

export default __exports__